import { Component, OnInit,EventEmitter,Output} from '@angular/core';
import {PushNotificationsService} from './../../push-notifications.service';

import {Router, ActivatedRoute, Params} from '@angular/router';
import { AlertsService } from '../../alerts/alerts.service';
import { ThemeService } from '../theme.service';
import { SocketService } from '../../shared/socket.service';
import { Listing } from '../../shared/listing';
import * as $ from "jquery";
import * as moment from 'moment';

@Component({
  selector: 'app-header',
  providers: [AlertsService],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends Listing implements OnInit {
  message;
  connection;
  badge=0;
  messages = [];
  items: any = [];
  name = localStorage.getItem('name');
  isAdmin: any = false;
  permissions: any;
  constructor(
    private alertsService: AlertsService,
    private klassService: ThemeService,
    private socketService: SocketService,
    private router: Router,
    private _notificationService: PushNotificationsService
  ) { 

    super();
   this._notificationService.requestPermission();
  }

  ngOnInit() {  
    this.permissions = JSON.parse(localStorage.getItem('permissions'));
    this.isAdmin = localStorage.getItem('isAdmin') === 'true';
  
    this.connection = this.socketService.getMessages().subscribe(message => {
      console.log("Message reveiving...",message);
      if(this.isAdmin || this.permissions[message['module_id']].departments.indexOf(message['department_id'])>=0){
        this.messages.push(message);


        let obj={
                  'title': 'Go Hotel Life',
                  'alertContent': message['title']
              }
        
        
        this.notify(obj);

       // this.badge = this.badge +  message['badge'];
        this.allNotifications();
        console.log("Message recieved!",  this.badge);


        
        //if(message["department_id"]=="59cba9963f8c5915e838e2b5"){
          this.playAudio();
       // }
        
      }

    })

     this.allNotifications();

  }


  playAudio(){
let audio = new Audio();
audio.src = "assets/beep.mp3";
audio.load();
audio.play();
}

notify(object) {
        let data: Array < any >= [];
        data.push(object);
       
        this._notificationService.generateNotification(data);
    }
  openMenu(){
    //LEFT MOBILE MENU OPEN

        $(".sb2-1").css("left", "0");
        $(".btn-close-menu").css("display", "inline-block");
        
  }

  closeMenu(){
     //LEFT MOBILE MENU CLOSE
        $(".sb2-1").css("left", "-350px");
        $(".btn-close-menu").css("display", "none");

  }

  ngOnDestroy() {
    this.connection.unsubscribe();
  }
  getItems(){}
  removeItem(){}
  toggleStatus(){}

  sendMessage(){
    this.socketService.sendMessage(this.message);
    this.message = '';
  }

  clearBash() {
    this.alertsService.clearBash().then((res) => {});;
  }

  allNotifications(click=false){
    this.filterParams.user_id = localStorage.getItem('userID');
    this.klassService.getNotifs(this.filterParams, 'en', 'admin/notification').then((res) => {
      if(!res)
        return true;

      if(this.isAdmin) {
       this.items = res.data;
      } else {
         this.items = res.data.filter(item => this.permissions[item.module_id].departments.indexOf(item.department_id)>=0 && this.permissions[item.module_id] && this.permissions[item.module_id].manage_orders);

       console.log(this.items)
        }
        this.badge = res.badge;
      if(click){
        this.badge = 0;
        this.clearBash();
      }

    });
  }

  notification(item){
    this.router.navigate([`/${item.url}`]);
    this.klassService.updateItem(item._id, {_id:item._id}, 'en',  'admin/notification').then((res) => {
      if(!res)
        return true;
      this.router.navigate([`/${item.url}`]);
    });

  }

  formatDate(dateTime) {
    if (Math.abs(moment().diff(dateTime)) < 1000) {
      return 'just now';
    }
    return moment(dateTime).fromNow();
  }

}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/theme/header/header.component.ts